// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenu_menu__tsrtU {
  padding-right: 1vw;
}
.SideMenu_menu__tsrtU button {
  margin: 1vh 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/SideMenu/SideMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,eAAA;AACJ","sourcesContent":[".menu {\n  padding-right: 1vw;\n\n  button {\n    margin: 1vh 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `SideMenu_menu__tsrtU`
};
export default ___CSS_LOADER_EXPORT___;
